import { memo, splitProps } from '../helpers.mjs';
import { createRecipe, mergeRecipes } from './create-recipe.mjs';

const buttonFn = /* @__PURE__ */ createRecipe('button', {
  "variant": "primary",
  "size": "small"
}, [
  {
    "size": "small",
    "variant": "modalCloseButton",
    "css": {
      "w": "32px",
      "borderRadius": "2px"
    }
  },
  {
    "size": "small",
    "variant": "link",
    "css": {
      "h": "auto",
      "p": "0",
      "textStyle": "text.small"
    }
  },
  {
    "size": "xsmall",
    "variant": "square",
    "css": {
      "h": "auto"
    }
  },
  {
    "size": "small",
    "variant": "square",
    "css": {
      "width": "40px",
      "height": "40px",
      "& svg": {
        "width": "28px",
        "height": "28px"
      }
    }
  },
  {
    "size": "small",
    "variant": "circle",
    "css": {
      "width": "40px",
      "height": "40px",
      "& svg": {
        "width": "28px",
        "height": "28px"
      }
    }
  }
])

const buttonVariantMap = {
  "variant": [
    "circle",
    "square",
    "primary",
    "secondary",
    "solid",
    "outline",
    "round",
    "ghost",
    "link",
    "subtle",
    "modalCloseButton",
    "unstyled",
    "text",
    "textBold"
  ],
  "size": [
    "xsmall",
    "small",
    "mid",
    "big",
    "unstyled"
  ]
}

const buttonVariantKeys = Object.keys(buttonVariantMap)

export const button = /* @__PURE__ */ Object.assign(memo(buttonFn.recipeFn), {
  __recipe__: true,
  __name__: 'button',
  __getCompoundVariantCss__: buttonFn.__getCompoundVariantCss__,
  raw: (props) => props,
  variantKeys: buttonVariantKeys,
  variantMap: buttonVariantMap,
  merge(recipe) {
    return mergeRecipes(this, recipe)
  },
  splitVariantProps(props) {
    return splitProps(props, buttonVariantKeys)
  },
  getVariantProps: buttonFn.getVariantProps,
})